<template>
  <!-- Navebar Area start -->
  <header id="header" class="header-section" :class="{ 'navbar-fixed-top animated slideInDown': isSticky }">
    <nav class="navbar">
      <router-link to="/" class="navbar-brand">
        <img src="/static/picture/logo.png" alt="Anovator">
      </router-link>
      <button class="mobile-menu-toggle" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div class="d-flex menu-wrap" :class="{ 'mobile-active': isMobileMenuOpen }" @click="handleMenuWrapClick">
        <div id="mainmenu" class="mainmenu">
          <ul class="nav">
            <li>
              <router-link 
                class="nav-link" 
                :class="{ active: $route.path === '/' }"
                to="/"
                @click="closeMobileMenu"
              >
                Home<span class="sr-only">(current)</span>
              </router-link>
            </li>
            <li class="li-products" @mouseenter="showProductsMenu" @mouseleave="hideProductsMenu">
              <a href="#productsDetail">Products</a>
              <div class="products-list" :class="{ show: isProductsMenuVisible }">
                <div @click="navigateToProduct('/a5')">
                  <img class="product-photo" src="/static/images/A5.png"/>
                  <router-link to="/a5">A5</router-link>
                </div>
                <div @click="navigateToProduct('/m3')">
                  <img class="product-photo" src="/static/images/M3.png"/>
                  <router-link to="/m3">M3</router-link>
                </div>
                <div @click="navigateToProduct('/m1')">
                  <img class="product-photo" src="/static/images/M1.png"/>
                  <router-link to="/m1">M1</router-link>
                </div>
                <div @click="navigateToProduct('/m0')">
                  <img class="product-photo" src="/static/images/M0.png"/>
                  <router-link to="/m0">M0</router-link>
                </div>
              </div>
            </li>
            <li>
              <a style="cursor: pointer;">Data service</a>
              <ul>
                <li><a href="https://www.anovator.com/admin/" target="_blank" @click="closeMobileMenu">Administrator Platform</a></li>
                <li><a href="https://docs.google.com/document/d/1o4EHv31S2ynU3pCBvoDD-ZT2-83mtEn1M_G43LZ55Vs/edit?usp=sharing" target="_blank" @click="closeMobileMenu">API Documentation</a></li>
              </ul>
            </li>
            <li>
              <router-link 
                :class="{ active: $route.path === '/faq' }"
                to="/faq"
                @click="closeMobileMenu"
              >
                Faq
              </router-link>
            </li>
            <li>
              <router-link 
                :class="{ active: $route.path === '/contact' }"
                to="/contact"
                @click="closeMobileMenu"
              >
                Contact
              </router-link>
            </li>
            <li>
              <router-link 
                :class="{ active: $route.path === '/about' }"
                to="/about"
                @click="closeMobileMenu"
              >
                About
              </router-link>
            </li>
            <li>
              <router-link 
                :class="{ active: $route.path === '/news' }"
                to="/news"
                @click="closeMobileMenu"
              >
                News
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
  <!-- Navebar Area End -->
</template>

<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      isSticky: false,
      isMobileMenuOpen: false,
      isProductsMenuVisible: false
    }
  },
  mounted() {
    this.initStickyHeader()
    this.initHeaderHeight()
    window.addEventListener('resize', this.initHeaderHeight)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.initHeaderHeight)
  },
  methods: {
    navigateToProduct(path) {
      this.$router.push(path)
      this.isMobileMenuOpen = false
    },
    navigateTo(path) {
      this.$router.push(path)
      this.isMobileMenuOpen = false
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    handleMenuWrapClick(event) {
      // 如果点击的是菜单背景区域（不是菜单内容），则关闭菜单
      if (event.target.classList.contains('menu-wrap')) {
        this.isMobileMenuOpen = false
      }
    },
    showProductsMenu() {
      this.isProductsMenuVisible = true
    },
    hideProductsMenu() {
      this.isProductsMenuVisible = false
    },
    initStickyHeader() {
      window.addEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      const yOffset = window.scrollY
      const triggerPoint = 80
      this.isSticky = yOffset >= triggerPoint
    },
    initHeaderHeight() {
      this.$nextTick(() => {
        const header = document.getElementById('header')
        if (header) {
          const height = header.offsetHeight
          const headerHeightElements = document.querySelectorAll('.header-height')
          headerHeightElements.forEach(el => {
            el.style.height = height + 'px'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
/* 移动端菜单按钮样式 */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
}

.mobile-menu-toggle span {
  width: 25px;
  height: 3px;
  background: #333;
  border-radius: 10px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 1px;
}

.mobile-menu-toggle.active span:first-child {
  transform: rotate(45deg);
}

.mobile-menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active span:nth-child(3) {
  transform: rotate(-45deg);
}

/* 产品菜单悬停效果 */
.products-list {
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.products-list.show {
  opacity: 1;
  visibility: visible;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: flex;
  }
  
  .menu-wrap {
    position: fixed;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100vh;
    background: white;
    transition: left 0.3s ease;
    z-index: 999;
    padding-top: 80px;
  }
  
  .menu-wrap.mobile-active {
    left: 0;
  }
  
  .nav {
    flex-direction: column;
    padding: 20px;
  }
  
  .nav li {
    margin: 10px 0;
  }
}
</style>